module.exports = __webpack_public_path__ + "static/media/NCIMlogo.1793c7a8.png";